// extracted by mini-css-extract-plugin
export default {"scrollBlock":"Contacts_scrollBlock__79hm3","modal":"Contacts_modal__UxOQY","title":"Contacts_title__zAj5v","block":"Contacts_block__CkIG9","float":"Contacts_float__9BXgO"};